let inFlightRefresh = null;

const REFRESH_LOCK_KEY = 'jwt.refreshLock';
const REFRESH_LOCK_TTL_MS = 8000;
const REFRESH_LOCK_POLL_MS = 50;

function readRefreshLock() {
  if (typeof window === 'undefined' || !window.localStorage) {
    return null;
  }

  try {
    const raw = window.localStorage.getItem(REFRESH_LOCK_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw);
    if (!parsed?.owner || !parsed.until || parsed.until < Date.now()) {
      window.localStorage.removeItem(REFRESH_LOCK_KEY);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export async function acquireRefreshLock() {
  if (typeof window === 'undefined' || !window.localStorage) {
    return 'local';
  }

  const existing = readRefreshLock();
  if (existing) {
    return null;
  }

  const owner = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  window.localStorage.setItem(
    REFRESH_LOCK_KEY,
    JSON.stringify({ owner, until: Date.now() + REFRESH_LOCK_TTL_MS })
  );
  await sleep(20);
  const confirmed = readRefreshLock();
  return confirmed?.owner === owner ? owner : null;
}

export async function waitForRefreshLockRelease(isFresh, timeoutMs = REFRESH_LOCK_TTL_MS) {
  const deadline = Date.now() + timeoutMs;
  while (Date.now() < deadline) {
    if (isFresh?.()) {
      return true;
    }
    if (!readRefreshLock()) {
      return Boolean(isFresh?.());
    }
    await sleep(REFRESH_LOCK_POLL_MS);
  }
  return Boolean(isFresh?.());
}

export function releaseRefreshLock(owner) {
  if (!owner || typeof window === 'undefined' || !window.localStorage) {
    return;
  }
  const current = readRefreshLock();
  if (!current || current.owner === owner) {
    window.localStorage.removeItem(REFRESH_LOCK_KEY);
  }
}

/**
 * Garantiza un único refresh concurrente. Todas las llamadas simultáneas
 * comparten la misma promesa hasta que finaliza.
 */
export function runSingleRefresh(refreshFn) {
  if (inFlightRefresh) {
    return inFlightRefresh;
  }

  inFlightRefresh = Promise.resolve()
    .then(() => refreshFn())
    .finally(() => {
      inFlightRefresh = null;
    });

  return inFlightRefresh;
}

export function resetRefreshQueueForTests() {
  inFlightRefresh = null;
  if (typeof window !== 'undefined' && window.localStorage) {
    window.localStorage.removeItem(REFRESH_LOCK_KEY);
  }
}
